import React from 'react'

import { SH3, Stack } from '@zet/design-system'
import { Wallet } from '@zet/feature-earnings/assests/svg'
import { i18n } from '@zet/localization'
import { DEVICE_HEIGHT } from '@zet/utils/Constants'

const ListEmptyComponent = () => {
  return (
    <Stack
      className="flex-1 items-center justify-center self-center"
      style={{ height: DEVICE_HEIGHT * 0.5 }}
    >
      <Wallet />
      <SH3 className="text-neutral-black100 mt-2">{i18n.t('noEarnings')}</SH3>
    </Stack>
  )
}

export default ListEmptyComponent
